export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";